module.exports = __webpack_public_path__ + "static/media/Person5.ad51aa6f.png";